import * as userRequest from "@/utils/userRequest";

interface QueryParams {
    startTime: string;
    endTime: string;
    keyword?: string;
}

export default async function getAffiliateService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any,
    queryParams?: QueryParams
) {
    try {
        const res = await userRequest.get("affiliates/get-affiliate-data", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: ((queryParams?.startTime && queryParams?.endTime) || queryParams?.keyword) && queryParams,
        });
        const fakeData = {
            status: 200,
            result: {
                msg: "Get data successfully",
                data: {
                    deposit: 0,
                    referral: 8,
                    avatar: "https://solx-dev-cdn.blocktrend.xyz/undefined/images/@user_NHm178_ae5e34ca-18fb-4caa-aca7-3173380c5d6c.jpeg",
                    affiliatePurchase: 76.034699585,
                    totalPurchase: 0,
                    telegram_id: 6007747939,
                    updatedAt: 1730362810593,
                    username: "@user_NHm178",
                    nickName: "Nguyen Khoa Diem",
                    createdAt: 1728267188672,
                    referral_id: "108CE96D0",
                    userId: "3a01465f-863a-40aa-8977-7c453e674727",
                    relationshipCreatedAt: 1728267235238,
                    solx_earned: 0,
                    rankingReward: 0,
                    commission: 0,
                    ranking: 2,
                    children: [
                        {
                            deposit: 0,
                            referral: 0,
                            avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                            affiliatePurchase: 0,
                            totalPurchase: 0,
                            telegram_id: 7062661508,
                            updatedAt: 1728965784360,
                            username: "@user_nn7736",
                            nickName: "Anh Thư",
                            createdAt: 1728965744578,
                            referral_id: "7D8CA8A06",
                            userId: "fc6562db-5876-4995-93b9-57f185037ca3",
                            relationshipCreatedAt: 1728965784360,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 3,
                            affiliateGroup: 0,
                            totalReferral: 0,
                        },
                        {
                            deposit: 0,
                            referral: 0,
                            affiliatePurchase: 0.9274782400000002,
                            totalPurchase: 0,
                            telegram_id: 7056779482,
                            updatedAt: 1730166429002,
                            username: "@user_1XY301",
                            nickName: "NiuBB",
                            createdAt: 1728635311145,
                            referral_id: "2A199818F",
                            userId: "ea1769e0-87a5-4668-833e-d12ae611ca5ex",
                            relationshipCreatedAt: 1728635337933,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 4,
                            affiliateGroup: 0,
                            totalReferral: 0,
                        },
                        {
                            deposit: 0,
                            referral: 0,
                            affiliatePurchase: 0.199847,
                            totalPurchase: 0,
                            telegram_id: 6320281160,
                            updatedAt: 1728634996571,
                            username: "@user_OZI301",
                            nickName: "Lý Thông",
                            createdAt: 1728633310620,
                            referral_id: "FD5A94B41",
                            userId: "1a775a9d-fcbe-49b8-972d-b2439c7271c2",
                            relationshipCreatedAt: 1728633330646,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 5,
                            affiliateGroup: 0,
                            totalReferral: 0,
                        },
                        {
                            deposit: 0,
                            referral: 0,
                            avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                            affiliatePurchase: 0,
                            totalPurchase: 0,
                            telegram_id: 6416958177,
                            updatedAt: 1728545138066,
                            username: "@user_tvX119",
                            nickName: "Tuấn Em Phan",
                            createdAt: 1728468947491,
                            referral_id: "D30625659",
                            userId: "a92ba559-220b-4069-a32a-dfd129af1175",
                            relationshipCreatedAt: 1728545138066,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 0,
                            affiliateGroup: 0,
                            totalReferral: 0,
                        },
                        {
                            deposit: 0,
                            referral: 1,
                            avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                            affiliatePurchase: 0.28,
                            totalPurchase: 0,
                            telegram_id: 2028314085,
                            updatedAt: 1730347607505,
                            username: "@user_NrTBuT",
                            nickName: "Nin 🍅 ",
                            createdAt: 1730340447284,
                            referral_id: "D884A7E62",
                            userId: "1769acdd-638b-4357-8a40-4814d6de39b9",
                            relationshipCreatedAt: 1730340517876,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 0,
                            affiliateGroup: 0,
                            totalReferral: 1,
                            children: [
                                {
                                    deposit: 0,
                                    referral: 0,
                                    avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                                    affiliatePurchase: 0,
                                    totalPurchase: 0,
                                    telegram_id: 7056779482,
                                    updatedAt: 1730347051298,
                                    username: "@user_2LBMEH",
                                    nickName: "NiuB ",
                                    createdAt: 1730347045987,
                                    referral_id: "FDE52A648",
                                    userId: "42116208-7901-45ab-98b2-d3fffa8e5c41",
                                    relationshipCreatedAt: 1730347051298,
                                    solx_earned: 0,
                                    rankingReward: 0,
                                    commission: 0,
                                    ranking: 0,
                                    affiliateGroup: 0,
                                    totalReferral: 0,
                                },
                            ],
                        },
                        {
                            deposit: 0,
                            referral: 0,
                            avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                            affiliatePurchase: 0,
                            totalPurchase: 0,
                            telegram_id: 6320281160,
                            updatedAt: 1728267451966,
                            username: "@user_B1l924",
                            nickName: "Lý Thông",
                            createdAt: 1728267443454,
                            referral_id: "1BC8BD04E",
                            userId: "90756805-a328-4ad1-9d24-1cfe861723a1",
                            relationshipCreatedAt: 1728267451966,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 0,
                            affiliateGroup: 0,
                            totalReferral: 0,
                        },
                        {
                            deposit: 0,
                            referral: 1,
                            avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                            affiliatePurchase: 0.7823149850000001,
                            totalPurchase: 0,
                            telegram_id: 2028314085,
                            updatedAt: 1730277286473,
                            username: "@user_CqSymG",
                            nickName: "Nin 🍅 ",
                            createdAt: 1728267302289,
                            referral_id: "2D419EF87",
                            userId: "a6046581-e5f1-4ab3-b951-bedbf161e23ex",
                            relationshipCreatedAt: 1728267303848,
                            solx_earned: 0,
                            rankingReward: 0,
                            commission: 0,
                            ranking: 1,
                            affiliateGroup: 0,
                            totalReferral: 1,
                            children: [
                                {
                                    deposit: 0,
                                    referral: 0,
                                    avatar: "https://solx-dev-cdn.blocktrend.xyz/sandbox/images/default_avt.svg",
                                    affiliatePurchase: 0,
                                    totalPurchase: 0,
                                    telegram_id: 6948115789,
                                    updatedAt: 1729762238347,
                                    username: "@user_yeOIX0",
                                    nickName: "Quang Nguyen",
                                    createdAt: 1728372923507,
                                    referral_id: "BF9597122",
                                    userId: "caa95089-2731-4ab9-b664-d764df74c405",
                                    relationshipCreatedAt: 1729762238347,
                                    solx_earned: 0,
                                    rankingReward: 0,
                                    commission: 0,
                                    ranking: 0,
                                    affiliateGroup: 0,
                                    totalReferral: 0,
                                },
                            ],
                        },
                    ],
                    affiliateGroup: 2.189640225,
                    totalReferral: 10,
                },
                ranks: [
                    {
                        id: "66eb8889d8a3d76c0397ccee",
                        level: 5,
                        rank_name: "Worldwide Ambassador",
                        description: "5% from each rank 5 referral deposits",
                        bonus: 5,
                        benefit: [
                            {
                                benefit: "benefit_lv5_1",
                                id: "66eb88898d3b680020d74e65",
                            },
                        ],
                        createdAt: "2024-09-19T02:12:25.569Z",
                        updatedAt: "2024-10-28T08:55:36.286Z",
                    },
                    {
                        id: "66eb8883d8a3d76c0397ccc1",
                        level: 4,
                        rank_name: "Continental Ambassador",
                        description: "4% from each rank 4 referral deposits",
                        bonus: 4,
                        benefit: [
                            {
                                benefit: "benefit_lv4_1",
                                id: "66eb88838d3b680020d74e64",
                            },
                        ],
                        createdAt: "2024-09-19T02:12:19.909Z",
                        updatedAt: "2024-10-28T09:19:01.139Z",
                    },
                    {
                        id: "66e0f5b8ff7b134676f51be2",
                        level: 0,
                        rank_name: "None Ambassador",
                        bonus: 0,
                        createdAt: "2024-09-11T01:43:20.487Z",
                        updatedAt: "2024-10-23T02:44:14.546Z",
                        benefit: [],
                    },
                    {
                        id: "66dad1cea01948dfe0c0d6d9",
                        level: 3,
                        rank_name: "Regional Ambassador",
                        description: "3% from each rank 3 referral deposits",
                        bonus: 3,
                        benefit: [
                            {
                                benefit: "benefit_lv3_1",
                                id: "66dad1ce7725ad002025ae4f",
                            },
                            {
                                benefit: "benefit_lv3_2",
                                id: "66dad1ce7725ad002025ae50",
                            },
                        ],
                        createdAt: "2024-09-06T09:56:30.824Z",
                        updatedAt: "2024-10-28T09:19:04.397Z",
                        icon: "66dad5a2a3f8ea363cb8d8db",
                    },
                    {
                        id: "66dad026a01948dfe0c0cc9d",
                        createdAt: "2024-09-06T09:49:26.816Z",
                        updatedAt: "2024-10-28T09:19:07.376Z",
                        benefit: [
                            {
                                benefit: "benefit_lv2_1",
                                id: "66dad0d77725ad002025ae4d",
                            },
                            {
                                benefit: "benefit_lv2_2",
                                id: "66dad0d77725ad002025ae4e",
                            },
                        ],
                        level: 2,
                        bonus: 2,
                        description: "2% from each rank 2 referral deposits",
                        rank_name: "National Ambassador",
                        icon: "66dad5faa3f8ea363cb8d9bf",
                    },
                    {
                        id: "66cc28b4f847fe32595224df",
                        level: 1,
                        rank_name: "City Ambassador",
                        description: "1% from each rank 1 referral deposits",
                        bonus: 1,
                        createdAt: "2024-08-26T07:03:16.806Z",
                        updatedAt: "2024-10-08T08:57:51.755Z",
                        benefit: [
                            {
                                benefit: "benefit_lv1_1",
                                id: "66cecb443154930020d38970",
                            },
                            {
                                benefit: "benefit_lv1_2",
                                id: "66cecb443154930020d38971",
                            },
                        ],
                        icon: "66dad6137f7c78ccf917eacf",
                    },
                ],
                success: true,
            },
        };
        console.log("🚀 ~ getAffiliateService ~ res:", res);
        // onSuccess && onSuccess(fakeData);
        // return fakeData;
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getAffiliateService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
